import {
  FaWhatsapp,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPhoneAlt,
} from "react-icons/fa";

import TopBar from "../components/TopBar";
import Navbar from "../components/Navbar";
import React, { useState } from "react";

export default function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("http://localhost:5000/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      alert(data.message);
    } catch (error) {
      alert("Failed to send message");
    }
  };

  return (
    <>
      <TopBar />
      <Navbar />

      <section className="bg-gray-50 min-h-screen py-12 px-4">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <span className="bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-semibold">
              CONTACT GM STORE
            </span>

            <h1 className="text-4xl font-bold mt-4 text-gray-800">
              Get In Touch With Us
            </h1>
          </div>

          <div className="grid lg:grid-cols-2 gap-10">
            {/* FORM */}
            <div className="bg-white rounded-3xl shadow-lg p-8">
              <h2 className="text-2xl font-bold mb-6">
                Send Us a Message
              </h2>

              <form onSubmit={handleSubmit} className="space-y-5">
                <input
                  name="name"
                  placeholder="Your Name"
                  onChange={handleChange}
                  className="w-full border px-4 py-3 rounded-xl"
                  required
                />

                <input
                  name="email"
                  type="email"
                  placeholder="Your Email"
                  onChange={handleChange}
                  className="w-full border px-4 py-3 rounded-xl"
                  required
                />

                <input
                  name="subject"
                  placeholder="Subject"
                  onChange={handleChange}
                  className="w-full border px-4 py-3 rounded-xl"
                  required
                />

                <textarea
                  name="message"
                  placeholder="Message"
                  rows="5"
                  onChange={handleChange}
                  className="w-full border px-4 py-3 rounded-xl"
                  required
                />

                <button
                  type="submit"
                  className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold"
                >
                  Send Message
                </button>
              </form>
            </div>

            {/* INFO (unchanged) */}
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-2xl shadow">
                <FaWhatsapp className="text-green-600 text-3xl" />
                <p>WhatsApp Support +92-343-5628108</p>
              </div>

              <div className="bg-white p-6 rounded-2xl shadow">
                <FaEnvelope className="text-blue-600 text-3xl" />
                <p>gmstorepkonline@gmail.com</p>
              </div>

              <div className="bg-white p-6 rounded-2xl shadow">
                <FaPhoneAlt className="text-orange-600 text-3xl" />
                <p>24/7 Support</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}